module.exports = __webpack_public_path__ + "media/images/icon_list/reply-d815fce0319f6e28b431aa5979798d4d.svg";